export const getOnboardingVideoUrl = (): string => {
  return process.env.VUE_APP_WELCOME_VIDEO_URL
    ? process.env.VUE_APP_WELCOME_VIDEO_URL
    : "";
};
